import type { MealProperty } from '@/types/pops'

const mealPropertiesMap = {
  nuts: 'Nuts',
  soy: 'Soy',
  spicy: 'Spicy',
  heatable: 'Heatable',
}

export function displayMealProperties(properties: Array<MealProperty>) {
  let includesProperties: Array<string> = []
  let otherProperties: Array<string> = []

  properties.forEach((property) => {
    if (property === 'nuts' || property === 'soy') {
      includesProperties.push(property)
    } else {
      otherProperties.push(mealPropertiesMap[property])
    }
  })

  const result = [
    includesProperties.length > 0
      ? `Includes ${includesProperties.join(', ')}`
      : null,
    ...otherProperties,
  ]

  return result.filter(Boolean).join(' • ')
}
